import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/auth/auth';
import SplineBackground from '../components/SplineBackground';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await authService.login(email, password);
      navigate('/app/chat');
    } catch (err: any) {
      setError(err.message || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center relative overflow-hidden">
      {/* Animated Background */}
      <SplineBackground />

      {/* Content Container */}
      <div className="w-full h-full flex items-center justify-between max-w-[1400px] px-12 relative z-10">
        {/* Login Card */}
        <div className="w-[400px] bg-[#111]/80 backdrop-blur-xl rounded-[20px] p-8 border border-white/[0.08] shadow-2xl">
          {/* Logo */}
          <div className="mb-12 flex justify-center">
            <img 
              src="/images/Logo branca.svg" 
              alt="LegatIA" 
              className="h-14 w-auto" 
            />
          </div>

          {/* Title */}
          <h1 className="text-[22px] font-everett text-white mb-2">
            Acesse sua conta
          </h1>
          <p className="text-[14px] text-[#8E95A3] font-everett mb-8">
            Se você já possui uma conta, preencha seus dados de acesso à plataforma.
          </p>

          {/* Form */}
          <form onSubmit={handleLogin} className="space-y-3">
            {error && (
              <div className="p-3 bg-red-500/10 border border-red-500/20 rounded-xl text-[14px] text-red-500">
                {error}
              </div>
            )}

            <div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-[48px] px-4 bg-white rounded-xl text-black text-[14px] font-everett placeholder-[#666] focus:outline-none focus:ring-2 focus:ring-[#00A3FF] transition-all"
                placeholder="E-mail"
                required
              />
            </div>

            <div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-[48px] px-4 bg-white rounded-xl text-black text-[14px] font-everett placeholder-[#666] focus:outline-none focus:ring-2 focus:ring-[#00A3FF] transition-all"
                placeholder="Senha"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full h-[48px] bg-white text-black font-everett text-[14px] rounded-xl hover:bg-[#F2F2F2] focus:ring-2 focus:ring-[#00A3FF] transition-all flex items-center justify-center group disabled:opacity-50 disabled:cursor-not-allowed mt-4"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin" />
              ) : (
                <div className="flex items-center">
                  Acessar sua conta
                  <svg className="w-4 h-4 ml-2 transition-transform duration-200 group-hover:translate-x-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.33337 8H12.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              )}
            </button>
          </form>

          {/* Footer Links */}
          <div className="flex items-center justify-between mt-6">
            <a href="#" className="text-[13px] text-[#8E95A3] hover:text-white transition-colors font-everett">
              Esqueceu sua senha?
            </a>
            <a href="#" className="text-[13px] text-[#8E95A3] hover:text-white transition-colors font-everett flex items-center group">
              Criar uma nova conta
              <svg className="w-4 h-4 ml-2 transition-transform duration-200 group-hover:translate-x-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.33337 8H12.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Tagline */}
        <div className="flex-1 flex justify-center items-center ml-24">
          <h2 className="text-[80px] font-everett text-white leading-[1.1] max-w-xl">
            Você é<br />único.
          </h2>
        </div>
      </div>
    </div>
  );
}
